export const load = () => ({
	h1: 'Window Guides: How Indow Inserts can Solve Your Unique Set of Challenges',
	title: 'Window Guides',
	description:
		"Understand the window challenges you face and learn about the solutions with Indow's helpful window guides.Find advice for different window types, buildings, or styles.",
	showTitle: true,
});
